import { render, staticRenderFns } from "./campainSetting.vue?vue&type=template&id=55cd5fee"
import script from "@/scripts/promotion/campainSetting.js?vue&type=script&lang=js&external"
export * from "@/scripts/promotion/campainSetting.js?vue&type=script&lang=js&external"
import style0 from "./campainSetting.vue?vue&type=style&index=0&id=55cd5fee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports